<template>
  <OrModalV3
    :is-open="isOpen"
    size="s"
    data-test="edit-queue-form"
    @close="$emit('close')"
  >
    <queues-form
      ref="queuesForm"
      error-reference="editQueue"
      :queue="queue"
      @update="handleUpdate"
    />
    <template #header>
      {{ $t('editQueue.title') }}
    </template>
    <template #footer>
      <div
        class="flex items-center justify-end gap-[16px]"
      >
        <OrButtonV3
          variant="outlined"
          @click="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </OrButtonV3>
        <OrButtonV3
          :loading="isUpdating"
          data-test="update-queue-button"
          @click="triggerUpdate"
        >
          {{ $t('common.save') }}
        </OrButtonV3>
      </div>
    </template>
  </OrModalV3>
</template>
<script lang="ts">
import { OrButtonV3, OrModalV3 } from '@onereach/ui-components';
import useVuelidate from '@vuelidate/core';
import { defineComponent, ref, PropType } from 'vue';

import QueuesForm from './QueuesForm.vue';
import { Queue, UpdateQueue } from '@/types';

export default defineComponent({
  name: 'QueueEditModal',
  components: {
    OrModalV3,
    OrButtonV3,
    QueuesForm,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isUpdating: {
      type: Boolean,
      required: true,
    },
    queue: {
      type: Object as PropType<Queue>,
      required: true,
    },
  },
  emits: ['close', 'update'],
  setup() {
    const queuesForm = ref<InstanceType<typeof QueuesForm>>();

    const v$ = useVuelidate({ $scope: 'QueuesForm' });

    return {
      queuesForm,
      v$,
    };
  },
  methods: {
    async triggerUpdate(): Promise<void> {
      this.v$.$touch();
      if (await this.v$.$validate()) {
        this.queuesForm?.update();
      }
    },
    async handleUpdate(queueData: UpdateQueue): Promise<void> {
      this.$emit('update', queueData);
    },
  },
});
</script>
